import { Box, Container, Typography } from "@mui/material";
import React, { useCallback } from "react";
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import Header from "../../Pages/Staking/Header";
import { NavLink } from "react-router-dom";
const particleOptions = {
  autoPlay: true,
  background: {
    color: {
      value: "red",
      opacity: "0.2",
    },
  },
  fpsLimit: 120,
  interactivity: {
    events: {
      onHover: {
        enable: true,
        mode: "grab",
      },
    },
    modes: {
      grab: {
        distance: 200,
        links: {
          opacity: 0.8,
        },
      },
    },
  },
  particles: {
    number: {
      value: 200,
    },
    color: {
      value: "#a0c8f0",
    },
    shape: {
      type: "polygon",
      polygon: {
        sides: 15,
      },
    },
    move: {
      // Enable particle movement
      enable: true,
      // Set the speed of particles
      speed: 2,
      // Enable particles to bounce off the edges
      bounce: true,
    },

    size: {
      value: 1, // Decrease the value to decrease particle size
      random: true, // Enable random size variation
      anim: {
        enable: false, // Disable size animation
        speed: 0, // Set animation speed to 0 (disabled)
        size_min: 0, // Set minimum size during animation
      },
    },
  },
};
const NewHeroSections = () => {
  const particlesInit = useCallback(async (engine) => {
    console.log(engine);
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    console.log(container);
  }, []);
  return (
    <Box
      sx={{
        position: "relative",
        background:
          "linear-gradient(98.3deg, rgb(0, 0, 0) 10.6%, rgb(255, 0, 0) 97.7%)",
        /* Additional styles for the container */
        width: "100%",
        minHeight: "100vh",
        height: "auto",
      }}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={particleOptions}
      />
      <Box sx={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}>
        <Header />
        <Container>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            flexDirection={"column"}
            height="70vh !important"
          >
            <Box width={"100%"} mt={6} px={{ sm: 8, xs: 3 }}>
              <Typography
                sx={{
                  fontSize: { sm: "30px", xs: "25px" },
                  fontFamily: "Roboto Slab",
                  color: "#CA3A38",
                  fontWeight: "900",
                }}
              >
                Our Vision
              </Typography>
              <Typography
                sx={{
                  fontSize: { sm: "25px", xs: "23px" },
                  fontFamily: "Roboto Slab",
                  color: "#fff",
                  fontWeight: "700",
                }}
              >
                Unleashing the Power of Staking
              </Typography>
              <Typography sx={{ fontSize: "20px", fontFamily: "Lato", mt: 1 }}>
                At De-Fi Sage, we are passionate about empowering individuals to
                take control of their financial future through decentralized
                finance (DeFi) solutions. Our mission is to revive staking and
                bring it to the forefront of the rapidly evolving digital
                landscape.
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <NavLink to="/explore" style={{ textDecoration: "none" }}>
                <Box
                  sx={{
                    cursor: "pointer",
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    fontWeight: "400",
                    color: "#fff",
                    border: "2px solid white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    lineHeight: "18px",
                    transition: "1s ease-in-out",
                    "&:hover": {
                      backgroundColor: "#fff",
                      color: "#E0115F",
                      transition: "1s ease-in-out",
                    },
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Lato",
                        textAlign: "center",
                        textTransform: "uppercase",
                      }}
                    >
                      Explore
                    </Typography>
                  </Box>
                </Box>
              </NavLink>
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default NewHeroSections;
